import styled from "@emotion/styled";
import { IconProps } from "./Icon.types";

export const IconWrapper = styled.div<
  Pick<
    IconProps,
    | "height"
    | "width"
    | "size"
    | "color"
    | "bgColor"
    | "borderRadius"
    | "cursor"
  >
>`
  display: flex;
  align-items: center;
  justify-content: center;
  // padding: 2px;
  width: ${(props) => props.width || "28"}px;
  height: ${(props) => props.height || "28"}px;
  font-size: ${(props) => props.size || "24"}px;
  color: ${(props) => props.color || "black"};
  background-color: ${(props) => props.bgColor || "transparent"};
  border-radius: ${(props) => props.borderRadius ?? "0"};
  cursor: ${(props) => props.cursor || "default"};
`;
